// Copyright 2020 Cartesi Pte. Ltd.
// Licensed under the Apache License, Version 2.0 (the "License"); you may not
// use this file except in compliance with the License. You may obtain a copy
// of the license at http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
// License for the specific language governing permissions and limitations
// under the License.
import { GameConstants } from '../GameConstants';
import { MathUtils } from '../utils/MathUtils';
import { Enemy } from './Enemy';
export class HealerEnemy extends Enemy {
    constructor(creationTick, engine) {
        super(GameConstants.ENEMY_HEALER, creationTick, engine);
        this.f =
            GameConstants.HEALER_HEALING_TICKS -
                (creationTick % GameConstants.HEALER_HEALING_TICKS);
        this.healing = false;
    }
    update() {
        this.f++;
        if (this.healing) {
            this.heal();
            if (this.f >= GameConstants.HEALER_STOP_TICKS) {
                this.f = 0;
                this.healing = false;
            }
        }
        else {
            super.update();
            // don't heal if it's too close from the exit
            if (this.f >= GameConstants.HEALER_HEALING_TICKS &&
                this.l < this.engine.enemiesPathCells.length - 2) {
                this.f = 0;
                this.healing = true;
            }
        }
    }
    heal() {
        // find all enemies in range and restore health
        for (let i = 0; i < this.engine.enemies.length; i++) {
            const enemy = this.engine.enemies[i];
            if (enemy.id === this.id) {
                // heal itself
                enemy.restoreHealth();
            }
            else {
                const distanceSquare = MathUtils.fixNumber((enemy.x - this.x) * (enemy.x - this.x) +
                    (enemy.y - this.y) * (enemy.y - this.y));
                if (distanceSquare <=
                    GameConstants.HEALER_HEALING_RADIUS *
                        GameConstants.HEALER_HEALING_RADIUS) {
                    enemy.restoreHealth();
                }
            }
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhbGVyRW5lbXkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2VuZW1pZXMvSGVhbGVyRW5lbXkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsbUNBQW1DO0FBRW5DLDhFQUE4RTtBQUM5RSw2RUFBNkU7QUFDN0UsK0RBQStEO0FBRS9ELHNFQUFzRTtBQUN0RSw0RUFBNEU7QUFDNUUsMkVBQTJFO0FBQzNFLDBFQUEwRTtBQUMxRSxxQkFBcUI7QUFFckIsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBQ2pELE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQztBQUUvQyxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sU0FBUyxDQUFDO0FBRWhDLE1BQU0sT0FBTyxXQUFZLFNBQVEsS0FBSztJQUtsQyxZQUFZLFlBQW9CLEVBQUUsTUFBYztRQUM1QyxLQUFLLENBQUMsYUFBYSxDQUFDLFlBQVksRUFBRSxZQUFZLEVBQUUsTUFBTSxDQUFDLENBQUM7UUFFeEQsSUFBSSxDQUFDLENBQUM7WUFDRixhQUFhLENBQUMsb0JBQW9CO2dCQUNsQyxDQUFDLFlBQVksR0FBRyxhQUFhLENBQUMsb0JBQW9CLENBQUMsQ0FBQztRQUV4RCxJQUFJLENBQUMsT0FBTyxHQUFHLEtBQUssQ0FBQztJQUN6QixDQUFDO0lBRU0sTUFBTTtRQUNULElBQUksQ0FBQyxDQUFDLEVBQUUsQ0FBQztRQUVULElBQUksSUFBSSxDQUFDLE9BQU8sRUFBRTtZQUNkLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztZQUVaLElBQUksSUFBSSxDQUFDLENBQUMsSUFBSSxhQUFhLENBQUMsaUJBQWlCLEVBQUU7Z0JBQzNDLElBQUksQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDO2dCQUNYLElBQUksQ0FBQyxPQUFPLEdBQUcsS0FBSyxDQUFDO2FBQ3hCO1NBQ0o7YUFBTTtZQUNILEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQztZQUVmLDZDQUE2QztZQUM3QyxJQUNJLElBQUksQ0FBQyxDQUFDLElBQUksYUFBYSxDQUFDLG9CQUFvQjtnQkFDNUMsSUFBSSxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLGdCQUFnQixDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQ2xEO2dCQUNFLElBQUksQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDO2dCQUNYLElBQUksQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDO2FBQ3ZCO1NBQ0o7SUFDTCxDQUFDO0lBRU8sSUFBSTtRQUNSLCtDQUErQztRQUMvQyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO1lBQ2pELE1BQU0sS0FBSyxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBRXJDLElBQUksS0FBSyxDQUFDLEVBQUUsS0FBSyxJQUFJLENBQUMsRUFBRSxFQUFFO2dCQUN0QixjQUFjO2dCQUNkLEtBQUssQ0FBQyxhQUFhLEVBQUUsQ0FBQzthQUN6QjtpQkFBTTtnQkFDSCxNQUFNLGNBQWMsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUN0QyxDQUFDLEtBQUssQ0FBQyxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFDO29CQUNuQyxDQUFDLEtBQUssQ0FBQyxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQzlDLENBQUM7Z0JBQ0YsSUFDSSxjQUFjO29CQUNkLGFBQWEsQ0FBQyxxQkFBcUI7d0JBQy9CLGFBQWEsQ0FBQyxxQkFBcUIsRUFDekM7b0JBQ0UsS0FBSyxDQUFDLGFBQWEsRUFBRSxDQUFDO2lCQUN6QjthQUNKO1NBQ0o7SUFDTCxDQUFDO0NBQ0oifQ==